export default __webpack_public_path__ + "static/media/canjs.f6ef7ff6.svg";